import { useState, useCallback } from 'react'
import { debounce } from 'lodash'
import { message } from 'antd'
import { readSystemUsersAggregate } from '../../../../Admin/system-users/utils/utils'
import { handleError } from '../../../../lib/utils'
import { buildPatientSearchQuery } from '../utils'

export const usePatientSearch = () => {
  const [searchResults, setSearchResults] = useState([])
  const [searching, setSearching] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  const handlePatientSearch = async () => {
    try {
      let tmpUsers = []
      setSearching(true)

      try {
        if (searchQuery) {
          const qry = buildPatientSearchQuery(searchQuery)
          tmpUsers = await readSystemUsersAggregate(qry)
        }
        setSearchResults(tmpUsers)
      } catch (e) {
        message.error(handleError(e))
      }
      setSearching(false)
    } catch (e) {
      setSearching(false)
    }
  }

  const handlePatientQuery = (query) => {
    setSearching(true)
    debouncedFilter(query)
  }

  // eslint-disable-next-line
  const debouncedFilter = useCallback(
    debounce((query) => {
      setSearchQuery(query)
    }, 1000),
    []
  )

  return {
    searchResults,
    searching,
    searchQuery,
    setSearchQuery,
    handlePatientSearch,
    handlePatientQuery
  }
}
